import { AfterViewInit, Component, Inject, Input, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { EBWModalMessageCustom, EBWModalResult } from '../model/ebw-modal.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogData {
  component: Type<unknown>;
  customButton?: Type<unknown>;
}

/** Componente che detiene la struttura delle modali */
@Component({
  selector: 'ebw-modal',
  templateUrl: './ebw-modal.component.html',
  styleUrls: ['./ebw-modal.component.scss']
})
export class EbwModalComponent implements OnInit, AfterViewInit {
  /** Tipi utilizzati per */
  resultTypes = EBWModalResult;

  /** messaggio da visualizzare */
  @Input() public message: EBWModalMessageCustom;

  public childComponentRef;
  public actionComponentRef;

  @ViewChild('customComponent', { read: ViewContainerRef }) private viewRef: ViewContainerRef;
  @ViewChild('customButton', { read: ViewContainerRef }) private actionRef: ViewContainerRef;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData, private dialogRef: MatDialogRef<EbwModalComponent>) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (this.data) {
      if (this.data.component) this.childComponentRef = this.viewRef.createComponent(this.data.component);
      if (this.data.customButton) this.actionComponentRef = this.actionRef.createComponent(this.data.customButton);
    }
  }

  closeModal() {
    this.dialogRef.close();
  }
}
